// This factory service is used to transform and return the  currency symbol to UI .
(function () {
  'use strict';
  angular.module('obex').
  factory('currency', function () {
    return {
      getCurrencySymbol(currencySymbol) {
        switch (currencySymbol) {
          case 'USD':
          case 'CAD':
            return '$';
          case 'EUR':
            return ' €';
          case 'GBP':
            return '£';
          case 'CNY':
            return ' ¥';
          default:
            return ((!!currencySymbol) ? currencySymbol : '');
        };
      },
    };
  });
})();



// WEBPACK FOOTER //
// ./client/js/services/currency.factory.js